import React, { useState, useEffect, forwardRef } from "react";
import { useForm } from "react-hook-form";
import TextField from "@mui/material/TextField";
import useFetch from "../../../../../hooks/useFetch";
import FileUploader from "../../../../shares/fileUploader/FileUplaoder";
import ModalShell from "../../../../shares/dashboard/ModalShell";

const FORM_ID = "add-book-form";

/**
 * Create / edit a book (جزوه). forwardRef for the MUI <Modal> child ref; the
 * POST/PATCH/GET wiring is unchanged.
 */
const AddBooks = forwardRef(({ close, get, edit }, ref) => {
  const [call, setCall] = useState({
    booksname: "",
    file: null,
  });

  const newGroup = useFetch({
    method: "POST",
    url: `management/books/`,
    noHeader: false,
    trigger: false,
    data: call,
    caller: get,
  });
  const editGroup = useFetch({
    method: "PATCH",
    url: `management/books/${edit}/`,
    noHeader: false,
    trigger: false,
    data: call,
    caller: get,
  });
  useFetch({
    method: "GET",
    url: `management/books/${edit}/`,
    noHeader: false,
    trigger: edit ? true : false,
    setter: setCall,
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ values: call });

  const onSubmit = () => {
    const formData = new FormData();
    formData.append("booksname", call.booksname);
    formData.append("file", call.file);
    setCall(formData);
    if (edit) {
      editGroup.reFetch();
    } else {
      newGroup.reFetch();
    }
  };

  useEffect(() => {
    newGroup.status === 201 && close();
  }, [newGroup.status]);
  useEffect(() => {
    editGroup.status === 200 && close();
  }, [editGroup.status]);

  const submitting = newGroup.loading || editGroup.loading;

  return (
    <ModalShell
      ref={ref}
      close={close}
      title={edit ? "ویرایش جزوه" : "جزوه جدید"}
      subtitle="فایل جزوه و عنوان آن را وارد کنید"
      footer={
        <div className="flex justify-start">
          <button
            form={FORM_ID}
            type="submit"
            disabled={submitting}
            className="rounded-soft bg-primary px-2xl py-sm text-base text-white transition-colors duration-150 hover:bg-primary-hover active:bg-primary-active focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary disabled:opacity-60 motion-reduce:transition-none"
          >
            {submitting ? "در حال ثبت…" : "ثبت جزوه"}
          </button>
        </div>
      }
    >
      <form
        id={FORM_ID}
        onSubmit={handleSubmit(onSubmit)}
        className="flex flex-col gap-xl"
        noValidate
      >
        <FileUploader
          value={call.file}
          onChange={(file) => setCall((prev) => ({ ...prev, file: file }))}
          label="بارگزاری جزوه"
        />

        <TextField
          label="عنوان"
          value={call.booksname}
          {...register("booksname", { required: "عنوان را وارد کنید" })}
          error={!!errors.booksname}
          helperText={errors.booksname?.message}
          onChange={(e) => setCall({ ...call, booksname: e.target.value })}
          fullWidth
        />
      </form>
    </ModalShell>
  );
});

export default AddBooks;
